const configs = {
  REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  POD_API_BASE_URL: process.env.REACT_APP_POD_API_BASE_URL,
  BOX_API_BASE_URL: process.env.REACT_APP_BOX_API_BASE_URL,
  BUSINESS_ID: process.env.REACT_APP_BUSINESS_ID,
  PAY_ACCESS_URL: process.env.REACT_APP_PAY_ACCESS_URL,
  PAYMENT_RESULT_URL: process.env.PAYMENT_RESULT_URL,
  PORTAL_KEY: "modal",
  SELECTOR_PORTAL_KEY: "selector-modal",
  TOKEN_ISSUER: 1,

  // Local storage keys:
  WALLET_ACCESS_KEY: "WALLET_ACCESS_KEY",
};
export default configs;
